export const MEDICAL_DEPLOYMENT_LABELS = {
  singular: "Despliegue de Unidad Médica Móvil",
  plural: "Despliegues de Unidades Médicas Móviles",
  singularShort: "Despliegue",
  pluralShort: "Despliegues",
};
